import TIM from 'tim-js-sdk'
import TIMUploadPlugin from 'tim-upload-plugin'
export default {
	data() {
		return {
			tim: null, //TIM实例
			userID: '',
			sdkAppID: '',
			groupID: '',
			userSig: '',

			chatList: [], //聊天信息
			loginInfo: {}, //tim信息
		}
	},
	methods: {
		initTimSdk() {
			// 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
			// const tim = TIM.create({
			//     SDKAppID: this.sdkAppID // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
			// })
			// // 设置 SDK 日志输出级别，详细分级请参见 <a href="https://web.sdk.qcloud.com/im/doc/zh-cn//SDK.html#setLogLevel">setLogLevel 接口的说明</a>
			// tim.setLogLevel(1) // 普通级别，日志量较多，接入时建议使用
			// // tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
			// // 注册腾讯云即时通信 IM 上传插件
			// tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
			// this.tim = tim

			// this.bindOnEvent()

			//当前用户身份
			this.loginInfo = {
				sdkAppID: this.sdkAppID, //用户所属应用id,必填
				appIDAt3rd: this.sdkAppID, //用户所属应用id，必填
				identifier: this.userID, //当前用户ID,必须是否字符串类型，选填
				identifierNick: '', //当前用户昵称，选填
				userSig: this.userSig, //当前用户身份凭证，必须是字符串类型，选填
				headurl: '', //当前用户默认头像，选填
				accountType: 1, //用户所属应用帐号类型，已废弃
			}
			this.sdkLogin()
		},
		//IE9(含)以下浏览器用到的jsonp回调函数
		jsonpCallback(rspData) {
			//设置接口返回的数据
			webim.setJsonpLastRspData(rspData)
		},
		//监听大群新消息（普通，点赞，提示，红包）
		onBigGroupMsgNotify(msgList) {
			for (var i = msgList.length - 1; i >= 0; i--) {
				//遍历消息，按照时间从后往前
				var msg = msgList[i]
				//console.warn(msg);
				webim.Log.warn(
					'receive a new avchatroom group msg: ' + msg.getFromAccountNick()
				)
				//显示收到的消息
				// var a=$(".liveChatBox")[0].scrollTop + $(".liveChatBox").height();
				// var b=$(".liveChatBox")[0].scrollHeight;
				// var scorll=false;
				// if(a>=b-50){
				// 	scorll=true;
				// }
				this.showMsg(msg)
				// if (scorll==true){
				// var c=$(".chatList").height()+100;
				// $(".liveChatBox").scrollTop(c);
				// }
			}
		},
		//监听新消息(私聊(包括普通消息、全员推送消息)，普通群(非直播聊天室)消息)事件
		//newMsgList 为新消息数组，结构为[Msg]
		onMsgNotify(newMsgList) {
			// var newMsg;
			// for (var j in newMsgList) { //遍历新消息
			//     newMsg = newMsgList[j];
			//     handlderMsg(newMsg); //处理新消息
			// }
		},
		set_member_profile(nickname, portrait, callback) {
			// 设置用户昵称
			var profile_item = [
				{
					Tag: 'Tag_Profile_IM_Nick',
					Value: nickname,
				},
				{
					Tag: 'Tag_Profile_IM_Image',
					Value: portrait,
				},
			]
			var options1 = {
				ProfileItem: profile_item,
			}
			webim.setProfilePortrait(
				options1,
				function(resp) {
					if (typeof callback === 'function') {
						callback()
					}
				},
				function(err) {
					//alert(err.ErrorInfo);
				}
			)
		},
		//sdk登录
		sdkLogin() {
			//web sdk 登录
			webim.login(
				this.loginInfo,
				{
					onConnNotify: this.onConnNotify, //选填
					jsonpCallback: this.jsonpCallback, //IE9(含)以下浏览器用到的jsonp回调函数,移动端可不填，pc端必填
					onBigGroupMsgNotify: this.onBigGroupMsgNotify, //监听新消息(大群)事件，必填
					onMsgNotify: this.onMsgNotify, //监听新消息(私聊(包括普通消息和全员推送消息)，普通群(非直播聊天室)消息)事件，必填
					onGroupSystemNotifys: {}, //监听（多终端同步）群系统消息事件，必填
					// "onGroupInfoChangeNotify": onGroupInfoChangeNotify//监听群资料变化事件，选填
				},
				{
					isAccessFormalEnv: this.isAccessFormalEnv, //是否访问正式环境，默认访问正式，选填
					isLogOn: false, //是否开启控制台打印日志,默认开启，选填
				},
				(identifierNick) => {
					//identifierNick为登录用户昵称(没有设置时，为帐号)，无登录态时为空
					this.set_member_profile(
						this.loginInfo.identifierNick,
						this.loginInfo.headurl,
						function() {
							webim.Log.info('昵称、头像设置成功')
						}
					)
					webim.Log.info('webim登录成功')
					this.applyJoinBigGroup(this.groupID) //加入大群
				},
				function(err) {
					console.log(err.ErrorInfo)
				}
			)
		},
		onConnNotify(resp) {
			switch (resp.ErrorCode) {
				case webim.CONNECTION_STATUS.ON:
					webim.Log.warn('连接状态正常...')
					break
				case webim.CONNECTION_STATUS.OFF:
					webim.Log.warn('连接已断开，无法收到新消息，请检查下你的网络是否正常')
					break
				default:
					webim.Log.error('未知连接状态,status=' + resp.ErrorCode)
					break
			}
		},
		//进入大群
		applyJoinBigGroup(groupId) {
			var options = {
				GroupId: groupId, //群id
			}
			webim.applyJoinBigGroup(
				options,
				function(resp) {
					//JoinedSuccess:加入成功; WaitAdminApproval:等待管理员审批
					if (resp.JoinedStatus && resp.JoinedStatus == 'JoinedSuccess') {
						webim.Log.info('进群成功')
					} else {
						console.log('进群失败')
					}
				},
				function(err) {
					console.log(err.ErrorInfo)
				}
			)
		},

		//显示消息（群普通+点赞+提示+红包）
		showMsg(msg) {
			let subType = msg.getSubType()
			if (subType !== webim.GROUP_MSG_SUB_TYPE.COMMON) {
				return
			}
			// <li><span class="userName">龙龙龙：</span>滴滴滴滴滴</li>
			var fromAccountNick, msg_txt, li
			fromAccountNick = msg.getFromAccountNick()
			if (!fromAccountNick) {
				fromAccountNick = '未知用户'
			}
			msg_txt = this.convertMsgtoHtml(msg)
			// console.log(msg_txt);
		},
		//把消息转换成Html
		convertMsgtoHtml(msg) {
			var elems = msg.getElems() //获取消息包含的元素数组

			for (var i in elems) {
				var elem = elems[i]
				var type = elem.getType() //获取元素类型
				var content = elem.getContent() //获取元素对象
				elem.nick = msg.fromAccountNick
				switch (type) {
					case 'TIMCustomElem':
						const data = JSON.parse(content.data)
						switch (data.type) {
							case 'question': // 提问
								this.handMessage(elem)
								break
							case 'gift': // 礼物
								this.handMessage(elem)
								break
							case 'text': // 普通文本消息
								this.handMessage(elem)
								break
							case 'teacher':
								this.handMessage(elem)
								break
							default:
								// 普通文本消息
								console.log('其他消息', item)
							// this.handOtherMessage(item)
						}
						break
				}
			}
			if (elems.length === 1 && elems[0].type === 'TIMTextElem') {
				let elem = elems[0]
				elem.nick = msg.fromAccountNick
				this.handMessage(elem, true)
			}
		},

		handMessage(dataElem, isText) {
			let text = {}
			let isQuestion = false

			const data = dataElem.content
			try {
				const customData = JSON.parse(data.data)
				if (customData.type === 'text') {
					text = {
						name: dataElem.nick,
						message: customData.data.msg,
						isSelf: false,
					}
				} else {
					// 自定义消息
					if (customData.type) {
						let message = ''
						switch (customData.type) {
							case 'gift':
								switch (customData.data.gift_type) {
									case 'flower':
										message = '送给老师一朵'
										break
									case 'like':
										message = '送给老师一个'
										break
									case 'amazing':
										message = '送给老师一个'
										break
								}
								break
							case 'question':
								message = customData.data.msg
								isQuestion = true
								break
							case 'teacher':
								message = customData.data.msg
								break
						}
						text = {
							name: dataElem.nick,
							message: message,
							isSelf: false,
							type: customData.type,
							gift_type: customData.data.gift_type,
						}
					}
				}
			} catch (e) {
				console.log(e)
			}

			if (isText) {
				text = {
					name: dataElem.nick,
					message: dataElem.content.text,
					isSelf: false,
				}
			}

			text.show = isQuestion === true

			// 设置ID
			text.id = this.chatList.length
			text.message = text.message.trim()
			this.chatList.push(text)
			console.log(text)
		},
	},
}
